import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-secomea',
  templateUrl: './secomea.component.html',
  styleUrls: ['./secomea.component.css']
})
export class SecomeaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
